<div class="td-score-development-card">
  <h2 class="td-card-title">{{ 'td_score_development' | translate }}</h2>
  <div class="td-chart-main-container">
    <div class="td-chart-header">
      <span class="td-card-subtitle">{{ 'td_score_development_subtitle' | translate }}</span>
      <div class="td-chips">
        <button type="button" class="indicator-button"
                *ngFor="let chip of chips; trackBy: trackByUuid"
                [ngClass]="{'indicator-button-active': chip.uuid === activeChipUuid}"
                [pTooltip]="chip.title" tooltipPosition="bottom" tooltipStyleClass="tooltip-style"
                (click)="selectChip(chip)">
          <img class="indicator-button-icon" [src]="chip.icon" [alt]="chip.title">
        </button>
      </div>
    </div>
    <div class="spinner-border text-primary td-chart-spinner" role="status" *ngIf="loading"></div>
    <ng-container *ngIf="!loading && hasData">
      <div *ngIf="showChart" echarts [options]="chartOption" [merge]="chartOption"
           class="chart chart-container line"></div>
      <div *ngIf="!showChart" echarts [options]="chartOption" [merge]="chartOption"
           class="chart chart-container line"></div>
    </ng-container>
    <span class="td-chart-empty" *ngIf="!loading && !hasData">{{ 'td_no_data' | translate }}</span>
  </div>
</div>
